import React from "react";
import Label from "components/crm/ui/Label";
import { cx } from "components/crm/ui/uiUtils";

// Grey border, orange on focus, red on error (never thicker).
const TextField = ({
  label,
  hint,
  icon: Icon,
  error,
  helper,
  multiline,
  className,
  id,
  inputRef,
  ...props
}) => {
  const Tag_ = multiline ? "textarea" : "input";
  return (
    <div className={cx("flex flex-col gap-2", className)}>
      {label && (
        <Label htmlFor={id} hint={hint}>
          {label}
        </Label>
      )}
      <div
        className={cx(
          "flex items-start gap-2 rounded-lg border bg-white p-3 transition-colors focus-within:border-primary",
          error
            ? "border-danger focus-within:border-danger"
            : "border-lineStrong"
        )}
      >
        {Icon && (
          <Icon
            size={18}
            className="mt-[1px] shrink-0 text-faint"
            strokeWidth={2}
          />
        )}
        <Tag_
          id={id}
          ref={inputRef}
          rows={multiline ? 2 : undefined}
          className="min-w-0 flex-1 resize-none bg-transparent text-sm font-medium leading-5 text-ink outline-none placeholder:text-faint"
          {...props}
        />
      </div>
      {(error || helper) && (
        <p
          className={cx(
            "-mt-1 text-xs leading-4",
            error ? "text-danger" : "text-faint"
          )}
        >
          {error || helper}
        </p>
      )}
    </div>
  );
};

export default TextField;
